exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.spacer[data-v-57db3e74] {\n  flex: 1;\n}\n", ""]);

